<template>
  <div class="introduce_box" ref="introduce_box">
    <div class="tit_bg">2024年度易班优质公开课征集评选活动方案</div>
    <div class="msg_box">
      <p>为进一步推动全国高校思想政治工作会议精神落地生根，深入贯彻落实上海高校思想政治工作会议的决策部署，抓好课堂育人、实践育人、网络育人的改革创新，增强互联网意识，易班网打造了“互联网+思政教育”一体化解决方案“易班优课”在线教学平台，整合易班共建高校优质教学资源，形成网上网下教育合力。</p>
      <p>今年易班优课平台为服务师生各项教学使用需求，将面向全国征集以高校新生入学教育、高校日常思政教育、大学生职业素养教育、大学生心理健康教育、大学生安全教育等5项专题内容为主的视频课程，每个分类评选出10部精品课程，总计50部，向全国高校进行专题推广宣传。</p>
    </div>
    <div class="msg_tit tit_1">参与对象</div>
    <div class="msg_box">
      全国易班共建高校<br>
      活动页网址：<a href="https://www.yooc.me/youke2024">https://www.yooc.me/youke2024</a>
    </div>
    <div class="msg_tit tit_2">活动时间</div>
    <div class="msg_box">
      活动时间：6月1日-9月30日<br/>
      课程征集时间：2024年1月1日-2024年8月31日<br/>
      投票评分时间：2024年6月1日-2024年8月31日<br/>
      专家评审时间：2024年9月<br/>
      获奖公示时间：2024年10月<br/>
    </div>
    <div class="msg_tit tit_3">课程类型</div>
    <div class="msg_box">
      <b>课程类型一：高校新生入学教育</b><br/>
      围绕“高校新生入学教育”的主题上传相关公开视频课程，帮助新生坚定理想信念，养成良好学风，勇于拼搏奋斗，提升素质能力。<br/>
      <b>课程类型二：高校日常思政教育</b><br/>
      围绕“高校日常思政教育”（包括：“四史”学习、学习二十大、高校思政教育、形势与政策、思政理论课、思政易家、课程思政）的主题上传相关公开视频课程，引领学生树立共产主义远大理想和中国特色社会主义共同理想。<br/>
      <b>课程类型三 ：大学生职业素养教育</b><br/>
      围绕“大学生职业素养教育”的主题上传相关公开视频课程，构建完善的大学生职业素养教育体系,引导大学生自我提高职业素养,为社会培养更多有用人。<br/>
      <b>课程类型四 ：大学生心理健康教育</b><br/>
      围绕“大学生心理健康教育”的主题上传相关公开视频课程，引导学生正确认识义和利、群和己、成和败、得和失，培育学生自尊自信、理性平和、积极向上的健康心态，促进学生心理健康素质与思想道德素质、科学文化素质协调发展。<br/>
      <b>课程类型五：大学生安全教育</b><br/>
      围绕“大学生安全教育”的主题上传相关公开视频课程，课程内容可包括但不限于：意识形态安全、国家安全、人身安全、消防安全、交通安全、财产安全、网络信息安全和防灾减灾救灾等方面的教育培训。<br/>
    </div>
    <div class="msg_tit tit_4">参赛方式及要求</div>
    <div class="msg_box">
      <b>参赛方式：</b><br/>
      方式一：课程征集截止前，在活动专题页点击“上传参赛课程”按钮，提交参赛视频课程，通过易班工作人员初审后，成功显示在专题活动页上的课程，表示为申报成功。<br/>
      方式二：2024年1月1日-课程征集截止日，成功在易班优课“共享课程”频道上线的公开课视频，对应相关的课程分类主题，时长在5分钟以上的课程会自动进入易班工作人员初审平台，审核通过成功显示在专题活动页上的课程，表示为申报成功。
    </div>
    <div class="msg_box">
      <b>上传分类选择规则</b><br/>
      <var></var>“高校新生入学教育”请选择“易班学院-新生教育课”；<br/>
      <var></var>“高校日常思政教育”请选择“易班学院-‘四史’学习、学习二十大、高校思政教育、形势与政策、思政理论课、思政易家、课程思政”；<br/>
      <var></var>“大学生职业素养教育”请选择“易班大学-职业素养”；<br/>
      <var></var>“大学生心理健康教育”请选择“易班学院-心理健康教育”；<br/>
      <var></var>“大学生安全教育”请选择“易班学院-安全教育”。<br/>
    </div>
    <div class="msg_box">
      <b>视频课程格式要求</b><br/>
      <var></var>1个课程对应1个视频；<br/>
      <var></var>单个视频时长必须超过5分钟；<br/>
      <var></var>视频文件类型为MP4；单个上传文件大小不能超过500M；<br/>
      <var></var>课程封面必须设计精美，格式:jpg/png ；尺寸:500*375 ；文件大小<500k；课程封面上需要有“课程名称+高校名称”；<br/>
      <var></var>视频流：视频编码H.264；比特率建议384;<br/>
      <var></var>音频流：音视频编码AAC；比特率建议96；<br/>
    </div>
    <div class="msg_box">
      <b>已上线课程修改方式</b><br/>
      老师对已经通过易班初审上线的课程需要进行修改，包括文字修改和视频修改，请联系易班优课运营老师，提交修改内容后，由易班优课运营老师人工修改。<br/>
    </div>
    <div class="msg_tit tit_5">投票及评审规则</div>
    <div class="msg_box">
      <var></var>所有参赛课程，视频时长超过5分钟的才能进入易班初审流程。<br/>
      <var></var>所有进入初审流程的课程，必须通过易班工作人员的人工初审，审核通过才进入专题展示页，进行公示投票评分。<br/>
      <var></var>本次活动首先进行全国师生的投票评分，在投票截止日之后，每个分类选总评分最高的10部课程，总计50部课程进入决赛。相关投票评分规则如下：<br/>
      （1）活动期间，每人只能为每部课程投票及评分一次，8月31日停止投票和评分。<br/>
      （2）评分将以：课程内容、讲师表现、拍摄质量三个维度作为评判标准，每个维度最多评3分，基础投票得1分，总计10分。<br/>
      （3）课程排行榜每天公示昨天五个分类总分最高的50部课程，8月31日之后停止投票、评分和排行榜更新。<br/>
      <var></var>8月31日之后，易班工作人员在每个课程分类未进入前十名的课程里挑选推荐10部课程并撰写推荐理由，总计50部课程进入决赛。挑选原则以视频内容和拍摄质量为主要评判依据。<br/>
      <var></var>9月份，公示进入决赛的100部课程名单。<br/>
      公示网址：<a href="javascript:;">https://www.yooc.me/youke2024/result100</a><br/>
      <var></var>9月份，易班组织专家组对100部进入决赛的课程进行评分，以专家组最终的评分和意见作为最终评选依据，每个分类评选出10部精品课程，分为一、二、三等奖和7个优秀奖，总计50部精品课程。专家评分相同的时候，以课程获得的投票总评分排序。<br/>
      <var></var>10月份，在专家评审结束后，易班总部会对50部获奖课程进行风格统一的包装制作，颁发相应的易班电子证书，并制作专题展示页进行相关的公示、宣传。<br/>
      公示网址：<a href="javascript:;">https://www.yooc.me/youke2024/result50</a><br/>
      <var></var>活动结束后，每部获奖课程会颁发一份易班电子证书，5个分类总计50份，电子证书可以在“易班电子证书查询系统”中查询，证书上包括：课程名称、学校名称等信息。<br/>
      易班电子证书查询系统网址：<br/>
      <a href="https://www.yiban.cn/Renzheng/showJzList#/" target="_blank">https://www.yiban.cn/Renzheng/showJzList#/</a><br/>
    </div>
    <div class="zs_box">
      <p>证书样式</p>
      <img src="../assets/images/img_1.png" />
      <em>易班在法律允许范围内对本活动保留最终解释权。</em>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import API from "../api";
import axios from "axios";
export default {
  name: "",
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
     
  },
  mounted() {
   
  },
  
  methods: {
    
  }
};
</script>
<style lang="scss" rel="stylesheet/stylus" type="text/stylus" scoped>
.introduce_box{
  padding: 10px 52px;
  position: relative;
  background: #fff;
  border-radius: 8px;
  .tit_bg{
    background: url('../assets/images/tit_bg.png') no-repeat;
    width: 543px;
    height: 48px;
    position: relative;
    top: -20px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    text-align: center;
    color: #fff;
    font-size: 24px;
    font-weight: bold;
    line-height: 48px;
  }
  .msg_box{
    font-size: 16px;
    margin-bottom: 25px;
    line-height: 26px;
    p{
      text-indent: 32px;
      line-height: 28px;
    }
    b{
      font-weight: bold;
    }
    a{
      color: #6990EB;
    }
    var{
      width: 10px;
      height: 10px;
      display: inline-block;
      background: url('../assets/images/icon_1.png') no-repeat;
      padding-right: 5px;
    }
    
  }
  .msg_tit{
    margin: 5px 0 10px 0;
    border-left: 6px #FF9B57 solid ;
    color: #FF9B57;
    font-size: 18px;
    font-weight: bold;
    line-height:18px;
    padding-left: 10px;
    height: 18px;
  }
  
  .zs_box{
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    margin: 0 0 30px 0;
    img{
      width: 325px;
      height: 460px;
      margin: 10px 0;
    }
    em{
      color: rgba(0,0,0,0.3);
      text-align: center;
      font-size: 12px;
      display: block;
      margin-top: 10px;
    }
  }
}
  
</style>


// WEBPACK FOOTER //
// introduce.vue?5f4734d7